//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { getContentLibraryAggregation } from '@apis/content-library/contentLibraryApi';
import { IContentLibraryAggregationRequest } from '@apis/content-library/contentLibraryApiModel';
import {
  MediaLibrarySearchTagHeaders,
  MediaLibrarySearchTagPrefixes,
} from '@components/media-filters/mediaFilterConstants';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export const useGetVisualTagsSuggestionsQuery = (
  req: Omit<IContentLibraryAggregationRequest, 'type'>,
) => {
  return useQuery({
    queryKey: [
      QueryKeyConstants.MediaFilters,
      QueryKeyConstants.MediaFiltersVisualTagsSuggestions,
      req,
    ],
    queryFn: ({ signal }) =>
      getContentLibraryAggregation(
        {
          ...req,
          type: 'VisualTags',
        },
        { signal },
      ),
    select: ({ visualTags }) => {
      return visualTags.map(({ count, tag }) => ({
        count,
        header: MediaLibrarySearchTagHeaders.semanticTags,
        label: tag,
        prefix: MediaLibrarySearchTagPrefixes.semanticTags,
      }));
    },
    staleTime: FIVE_MINUTES_STALE_TIME,
    keepPreviousData: true,
  });
};
